import {Button} from '@wandb/components';
import {IconLightbulbInfo} from '@wandb/weave/components/Icon';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import * as React from 'react';

import {useStablePanelId} from '../Panel/PanelIDContext';
import {getDatadogRum} from './../../util/datadog';
import {usePanelSystemMetricsContext} from './SystemMetrics/PanelSystemMetricsContext';

const DD_RUM = getDatadogRum();

export const DelayRender = ({title}: {title: string}) => {
  const stablePanelId = useStablePanelId();
  const {setAllowUncappedMetrics} = usePanelSystemMetricsContext();

  React.useEffect(() => {
    DD_RUM.addAction('system_metrics_capped_panel_mounted', {
      title,
      panelId: stablePanelId,
    });
  }, [title, stablePanelId]);

  return (
    <TailwindContents>
      <div className="items-center justify-center flex flex-col gap-8 p-8 text-center grid-area=['delay-render']">
        <div className="rounded-full bg-blue-200 h-48 w-48 flex items-center justify-center">
          <IconLightbulbInfo className="text-blue-600" height={24} />
        </div>
        <div className="text-sm py-8">
          This panel includes a large number of metrics and runs, which may
          affect workspace performance.
        </div>
        <Button
          variant="secondary"
          size="sm"
          onClick={() => {
            DD_RUM.addAction('system_metrics_capped_panel_displayed', {
              title,
              panelId: stablePanelId,
            });
            setAllowUncappedMetrics(true);
          }}>
          Load anyway
        </Button>
      </div>
    </TailwindContents>
  );
};
